<template>
  <div class="radios-wrapper">
    <div class="radio-wrapper" v-for="n in parseInt(amount)" :key="n">
      <input
        type="radio"
        :id="'radio-' + n"
        :name="name"
        :value="(n - 1) * 10"
        @change="radioChecked"
        v-model="selectedRadio"
      >
      <label :for="'radio-' + n">{{ n - 1 }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "entry", "data", "amount"],

  data() {
    return {
      selectedRadio: this.entry ? this.entry.data[this.data] : 0
    };
  },

  methods: {
    radioChecked(event) {
      this.$emit("store-number", event.target.value);
    }
  }
};
</script>

<style scoped>
label {
  display: inline-block;
  margin: 0;
  text-align: center;
}
input {
  appearance: none;
  background-color: var(--light-grey);
  border: 1px solid var(--battleship-grey);
  border-radius: 50%;
  height: 1.5rem;
  margin-bottom: 0.5rem;
  transition: background-color 0.15s;
  width: 1.5rem;
}
input:checked {
  background-color: var(--michigan-blue);
  transition: background-color 0.15s;
}
.radios-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: -0.5rem;
}
.radio-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
}
</style>
